<template>
	<div class="make-aquestion">
		<pageTop ref="pageTop" @setCurrentTopic="setCurrentTopic"></pageTop>
		<div class="page-content">
			<div class="tiku-name" ref="testHeight">{{tikuName}}</div>
			<!-- 错题本为空 -->
			<div v-if="type == 2 && subjectList.length == 0 && showProfessor" class="wrongquestion-empty">
				<img src="@/assets/img/preliminaryClassic/professor.png" alt="">
				<p>错题本空空如也，快去刷题吧~</p>
			</div>
			<template v-else>
				<!-- 题目 -->
				<div class="subject-con">
					<div class="subject-info" v-if="subjectList.length">
						<div class="subject-title">
							<img v-if="subjectList[currentTopic].is_multiple=='0'" class="subject-type"
								src="@/assets/img/preliminaryClassic/radio.png" alt="">
							<img v-else class="subject-type" src="@/assets/img/preliminaryClassic/multiple.png" alt="">
							<pre ref="subjectName" class="katex-con" v-html="markedText(subjectList[currentTopic].description)"></pre>
						</div>
						<div class="answer-list">
							<el-row :gutter="50" v-for="(a, i) in optionRow" :key="i">
								<el-col :span="12" v-for="(b, j) in 2" :key="i+'-'+j">
									<template v-if="2*i+j < Object.keys(subjectList[currentTopic].option).length">
										<!-- <div class="answer-item" :class="judgingRightOrWrong(optionKey[2*i+j])" @click="optionSelected(subjectList[currentTopic].id, optionKey[2*i+j])"> -->
										<div class="answer-item" :class="judgingRightOrWrong(optionKey[2*i+j])"
											@click="optionSelected(subjectList[currentTopic].id, optionKey[2*i+j])">
											<div class="selection-box"
												:class="subjectList[currentTopic].is_multiple=='0'?'select-radio':'select-checkbox'">
												<!-- 单选与多选选中 -->
												<span v-if="subjectList[currentTopic].is_multiple=='0'" class="radio-box"></span>
												<span v-if="subjectList[currentTopic].is_multiple!='0'" class="iconfont icon-dui"></span>
												<!-- 回看对与错图标 -->
												<span class="iconfont icon-gou"></span>
												<span class="iconfont icon-X"></span>
											</div>
											<pre ref="subjectName" class="katex-con"
												v-html="markedText(optionKey[2*i+j]+'：'+subjectList[currentTopic].option[optionKey[2*i+j]])"></pre>
										</div>
									</template>
								</el-col>
							</el-row>
						</div>
					</div>
				</div>
				<!-- 按钮 -->
				<div class="subject-btn">
					<div class="button button-prev" @click="changeSubject('prev')">上一题</div>
					<div class="button button-next" @click="changeSubject('next')">下一题</div>
					<div v-if="!isLookingBack" class="button button-prohibit-submit" :class="isSelectAll&&'button-submit'"
						@click="submitSubject">提交</div>
					<div v-show="addCollect" class="button button-add-collect" @click="addUserCollect">加入错题本</div>
					<div v-show="removeCollect" class="button button-submit" @click="removeUserCollect">移除错题本</div>
				</div>
			</template>
		</div>
		<challengeResults ref="challengeResults" @lookingBack="lookingBack"></challengeResults>
	</div>
</template>

<script>
	import pageTop from '../components/pageTop';
	import challengeResults from '../components/challengeResults';
	import formulaModule from '@wangeditor/plugin-formula'
	import {
		getTikuProblemList,
		getUserCollectTikuProblemList,
		getEveryTikuProblemList,
		getSubmitTiku,
		addUserCollect,
		submitUserCollectTiku,
		removeUserCollect,
		submitEveryTiku,
		getFinishEveryTiku
	} from '@/api/preliminaryClassic'
	import marked from 'marked';
	import {
		objIsPro
	} from "@/utils/validate"
	export default {
		name: "makeAquestion",
		components: {
			pageTop,
			challengeResults,
		},
		data() {
			return {
				type: 1, // 1.自由练习，2.错题本，3.每日挑战
				tikuId: "", // 自由练习题库ID
				tikuName: "", // 自由练习题库名
				subjectList: [], // 题目列表
				subjectAnswer: [], // 答案
				currentTopic: 0, // 当前题目
				optionKey: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N"],
				isSelectAll: false, // 是否答题完成
				isLookingBack: false, // 是否回看
				showProfessor: false,
			}
		},
		created() {
			window.addEventListener('keydown', this.handleKeyDown);
			this.type = parseInt(this.$route.query.type);
			if (this.type == 1) {
				this.tikuId = this.$route.query.tikuId
				this.tikuName = this.$route.query.tikuName
				this.getTikuProblemList();
			} else if (this.type == 2) {
				this.getUserCollectTikuProblemList();
			} else if (this.type == 3) {
				this.getEveryTikuProblemList();
			}
		},
		destroyed() {
			window.removeEventListener('keydown', this.handleKeyDown);
		},
		mounted() {
			this.$nextTick(() => {
				let times = setInterval(_ => {
					let katexDom = document.getElementsByClassName("katex-con");
					if (katexDom.length != 0) {
						clearInterval(times);
						for (var i = 0; i < katexDom.length; i++) {
							this.$formula(katexDom[i])
						}
					}
				}, 10)
			});
		},
		watch: {
			currentTopic() {
				this.$nextTick(() => {
					let katexDom = document.getElementsByClassName("katex-con");
					for (var i = 0; i < katexDom.length; i++) {
						this.$formula(katexDom[i])
					}
				});
			}
		},
		computed: {
			addCollect() {
				return this.isLookingBack && this.type != 2 && !this.subjectList[this.currentTopic].is_collect
			},
			removeCollect() {
				return this.isLookingBack && (this.type == 2 || this.subjectList[this.currentTopic].is_collect)
			},
			optionRow() {
				return Math.ceil(Object.keys(this.subjectList[this.currentTopic].option).length / 2);
			},
			judgingRightOrWrong() {
				return (item) => {
					let choice = this.subjectList[this.currentTopic].choice; // 做题选择的答案
					if (!this.isLookingBack) {
						if (choice.includes(item)) return "answer-gou"
					} else {
						let correct = this.subjectList[this.currentTopic].correct; // 是否正确
						let correctAnswer = this.subjectList[this.currentTopic].correct_answer; // 正确答案
						if (correct && correctAnswer.includes(item)) {
							return "answer-dui answer-border answer-gou"
						} else if (!correct && correctAnswer.includes(item) && choice.includes(item)) {
							return "answer-dui answer-border answer-gou"
						} else if (!correct && correctAnswer.includes(item) && !choice.includes(item)) {
							return "answer-dui"
						} else if (!correct && !correctAnswer.includes(item) && choice.includes(item)) {
							return "answer-cuo answer-border answer-gou"
						}
					}
				}
			},
			markedText() {
				return (text) => {
					return marked.parse(text, {
						mangle: false,
						headerIds: false,
						gfm: true, //允许 Git Hub标准的markdown
						breaks: true, //允许回车换行（该选项要求 gfm 为true）
						sanitize: false, //对输出进行过滤（清理），将忽略任何已经输入的html代码（标签
					});
				}
			},
		},
		methods: {
			async getTikuProblemList() { // 获取错题本
				let res = await getTikuProblemList({
					tikuId: this.tikuId
				});
				// console.log("自由练习题目：", JSON.parse(JSON.stringify(res.data.list)));
				this.setSubjectList(res.data.list);
			},
			async getUserCollectTikuProblemList() { // 获取错题本
				let res = await getUserCollectTikuProblemList();
				// console.log("错题本：", JSON.parse(JSON.stringify(res.data.list)));
				this.setSubjectList(res.data.list);
			},
			async getEveryTikuProblemList() { // 获取每日挑战题目
				let res = await getEveryTikuProblemList();
				// console.log("每日挑战：", JSON.parse(JSON.stringify(res.data.list)));
				this.setSubjectList(res.data.list);
			},
			setSubjectList(list) {
				let isEvery = false;
				list.map(item => {
					if (this.type == 3 && objIsPro(item, "answer") && item.answer.length) {
						if (!isEvery) isEvery = true;
						item["choice"] = item.answer;
						item["correct_answer"] = item.answer;
						item["correct"] = true;
						item["is_collect"] = item.is_collect;
					} else {
						item["choice"] = []; // 选择的答案
					}
				})
				if (isEvery) {
					this.isLookingBack = true;
				}
				this.subjectList = list;
				this.$refs.pageTop.setSubjectList(list);
				this.showProfessor = true;
			},
			setCurrentTopic(num) { // 切换题目
				this.currentTopic = num;
			},
			optionSelected(id, option) { // 选中选项
				if (this.isLookingBack) return; // 回看禁止选择
				let subjectList = this.subjectList;
				let subInfo = this.subjectList[this.currentTopic];
				if (subInfo["choice"].includes(option)) {
					subInfo["choice"] = subInfo["choice"].filter(a => a != option);
				} else {
					if (subInfo.is_multiple == '0') subInfo["choice"] = [option]
					else subInfo["choice"].push(option)
				}

				// 判断题目是否做完
				this.isSelectAll = true;
				for (let i = 0; i < subjectList.length; i++) {
					if (subjectList[i].choice.length == 0) {
						this.isSelectAll = false;
						break
					}
				}
			},
			changeSubject(type) { // 切换题目
				let current = this.currentTopic;
				let newCurrent = type == 'prev' ? current - 1 : current + 1;
				if (newCurrent < 0) {
					this.$message({
						type: 'warning',
						message: '已经是第一题了',
						showClose: true
					})
				} else if (newCurrent > this.subjectList.length - 1) {
					this.$message({
						type: 'warning',
						message: '已经是最后一题了',
						showClose: true
					})
				} else {
					this.currentTopic = newCurrent;
					this.$refs.pageTop.changeSubject(newCurrent);
				}
			},
			async submitSubject() { // 提交答案
				if (this.isSelectAll) {
					let data = {
						tikuId: this.tikuId,
						answerData: []
					}
					this.subjectList.map(item => {
						data.answerData.push({
							problemId: item.id,
							answer: item.choice,
							multiple: item.is_multiple
						})
					})
					let res = null;
					if (this.type == 1) { // 自由练习
						res = await getSubmitTiku(data);
					} else if (this.type == 2) { // 错题本
						delete data.tikuId;
						res = await submitUserCollectTiku(data);
					} else if (this.type == 3) { // 每日挑战
						delete data.tikuId;
						res = await submitEveryTiku(data);
					}
					if (res) {
						// console.log("提交题目", JSON.parse(JSON.stringify(res.data)));
						let answerData = res.data.format_answer_data;
						if (this.type == 3) {
							let finishEvery = answerData.filter(item => item.correct);
							if (finishEvery.length == answerData.length) {
								this.$store.dispatch("user/setFinishEveryTiku", {
									finish: true,
									rank: 0
								});
							}
						}
						this.subjectAnswer = answerData;
						this.$refs.challengeResults.open(res.data.tiku_record_data);
					}
				} else {
					this.$message.warning("题目未做完，无法提交");
				}
			},
			handleKeyDown(event) { // 键盘左右键切换上题和下题
				if (event.keyCode === 37) {
					this.changeSubject('prev');
				} else if (event.keyCode === 39) {
					this.changeSubject('next');
				} else if (event.keyCode === 32) {
					// this.optionSelected("", "A");
				}
			},
			lookingBack() { // 回看
				this.isLookingBack = true;
				this.currentTopic = 0;
				this.$refs.pageTop.changeSubject(0);
				this.$refs.pageTop.setLookingBack(true);
				this.subjectList.map(item => {
					let answerInfo = this.subjectAnswer.find(a => a.csbd_problem_id == item.id);
					item["answer"] = answerInfo.answer; // 填写的答案
					item["correct_answer"] = answerInfo.correct_answer; // 正确答案
					item["correct"] = answerInfo.correct; // 是否正确
					item["is_collect"] = answerInfo.is_collect; // 是否在错题本
				})
				this.$refs.pageTop.setSubjectList(this.subjectList);
			},

			async addUserCollect() { // 加入错题本
				let res = await addUserCollect({
					problemId: this.subjectList[this.currentTopic].id
				});
				if (res.status === 1) {
					this.$message.success("加入错题本成功");
					let item = this.subjectList[this.currentTopic];
					item.is_collect = true;
					this.$set(this.subjectList, this.currentTopic, item);
				} else this.$message.error(res.message);
			},
			async removeUserCollect() { // 移除错题本
				let id = this.subjectList[this.currentTopic].id;
				let res = await removeUserCollect({
					problemId: id
				});
				if (res.status === 1) {
					this.$message.success("移除错题本成功");
					if (this.isLookingBack && this.type == 2) {
						this.subjectList = this.subjectList.filter(a => a.id != id);
						this.$refs.pageTop.setSubjectList(this.subjectList);
						if (this.currentTopic == this.subjectList.length) {
							this.currentTopic = this.subjectList.length - 1;
							this.$refs.pageTop.changeSubject(this.subjectList.length - 1);
						}
					} else if (this.isLookingBack && this.type != 2) {
						let item = this.subjectList[this.currentTopic];
						item.is_collect = false;
						this.$set(this.subjectList, this.currentTopic, item);
					}
				} else this.$message.error(res.message);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.make-aquestion {

		.page-content {
			position: absolute;
			top: 4.2rem;
			width: 100%;
			height: calc(100% - 4.2rem);
			color: #FFF;
			// display: none;

			.tiku-name {
				height: 2.32rem;
				line-height: 2.32rem;
				background-color: #259DA7;
				width: 100%;
				padding-left: 2.48rem;
			}

			.wrongquestion-empty {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				height: 100%;

				img {
					width: 10.72rem;
					height: 18.8rem;
				}

				p {
					font-size: 1.28rem;
					margin-top: 3rem;
				}
			}

			.subject-con {
				padding: 0 4.8rem;
				overflow-y: auto;
				height: calc(100% - 6.5rem);

				.subject-info {
					.subject-title {
						position: relative;
						margin: 2.5rem 0 2rem;
						user-select: none;

						.subject-type {
							position: absolute;
							width: 5rem;
							height: 3.6rem;
							top: 0;
							left: 0;
						}

						pre {
							min-height: 6rem;
							justify-content: center;
							font-size: 1.6rem;
							line-height: 2.1rem;
							padding: 1.6rem 2.4rem;
							background-color: rgba(29, 78, 100, 0.8);
							border-radius: 0.32rem;
							white-space: inherit;
							user-select: none;


							::v-deep p>code {
								display: initial;
							}

							::v-deep code {
								background: #0A3446;
								color: #9ef2ff;
								border-radius: 0.4rem;
								padding: 0.1rem 0.6rem;
							}

							::v-deep a {
								pointer-events: none;
								color: #FFF;
							}
						}
					}

					.answer-list {
						.answer-item {
							margin-bottom: 1.6rem;
							cursor: pointer;
							position: relative;
							border-radius: 0.32rem;

							.selection-box {
								width: 0.88rem;
								height: 0.88rem;
								border: 2px solid #26D1DF;
								position: absolute;
								left: 1.2rem;
								top: 50%;
								transform: translate(0, -50%);
							}

							.radio-box {
								background-color: #26D1DF;
								border-radius: 50%;
								width: 0.6rem;
								height: 0.6rem;
								position: absolute;
								top: calc(50% - 0.3rem);
								left: calc(50% - 0.3rem);
								display: none;
							}

							.icon-dui {
								color: #26D1DF;
								font-size: 1.1rem;
								position: absolute;
								left: -2px;
								top: -2px;
								display: none;
							}

							.icon-gou {
								color: #00FF0C;
								position: absolute;
								font-size: 1.4rem;
								top: -0.4rem;
								left: -0.08rem;
								display: none;
							}

							.icon-X {
								color: #F60000;
								position: absolute;
								font-size: 1.6rem;
								top: -0.3rem;
								left: -0.3rem;
								display: none;
							}

							.selection-box.select-radio {
								border-radius: 50%;
							}

							.selection-box.select-checkbox {}

							pre {
								padding: 1rem 1.2rem 1rem 3.5rem;
								background-color: rgba(29, 78, 100, 0.8);
								border-radius: 0.32rem;
								font-size: 1.2rem;
								white-space: inherit;
								user-select: none;

								::v-deep p {
									img {
										max-width: 100%;
									}

									a {
										pointer-events: none;
										color: #FFF;
									}

									code {
										display: inline;
										background: none;
										border-radius: 0.16rem;
										white-space: initial;
										color: #FFF;
										padding: 0;
									}
								}
							}
						}

						.answer-gou {
							background-color: #1C93AD;

							.radio-box,
							.icon-dui {
								display: inline-block;
							}
						}

						.answer-dui {
							background-color: rgba(15, 149, 211, 1);

							.icon-gou {
								display: inline-block;
							}
						}

						.answer-cuo {
							background-color: rgba(28, 147, 173, 0.8);

							.icon-X {
								display: inline-block;
							}
						}

						.answer-border {
							box-shadow: 0 0 0 2px #41f1ff;
						}

						.answer-gou,
						.answer-dui,
						.answer-cuo {
							pre {
								background-color: rgba(0, 0, 0, 0);
							}
						}
					}
				}
			}

			.subject-btn {
				display: flex;
				justify-content: flex-end;
				position: absolute;
				right: 4.8rem;
				bottom: 1.6rem;

				.button {
					width: 7.6rem;
					height: 2.08rem;
					background-size: 100%;
					background-repeat: no-repeat;
					color: #FFF;
					font-size: 1.04rem;
					text-align: center;
					line-height: 2.08rem;
					cursor: pointer;
					margin-left: 1rem;
					user-select: none;
				}

				.button-prev {
					background-image: url(~@/assets/img/preliminaryClassic/ben.png);
				}

				.button-next {
					background-image: url(~@/assets/img/preliminaryClassic/ben.png);
				}

				.button-prohibit-submit {
					background-image: url(~@/assets/img/preliminaryClassic/submit.png);
				}

				.button-submit {
					background-image: url(~@/assets/img/preliminaryClassic/join.png);
				}

				.button-add-collect {
					background-image: url(~@/assets/img/preliminaryClassic/add.png);
				}
			}
		}
	}
</style>
